import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { validatePassword, PASSWORD_HINT } from "../passwordPolicy";
import usePlayerManifest from "../hooks/usePlayerManifest";
import PlayerLayout from "../components/PlayerLayout";
import PasswordInput from "../components/PasswordInput";

export default function PlayerChangePassword() {
  usePlayerManifest();
  const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const forced = searchParams.get("forced") === "true";
  const token = sessionStorage.getItem("player_token");

  const handleSubmit = async () => {
    setError(""); setSuccess("");
    if (!form.currentPassword || !form.newPassword || !form.confirmPassword)
      return setError("All fields are required");
    if (form.newPassword !== form.confirmPassword)
      return setError("New passwords do not match");
    const passwordError = validatePassword(form.newPassword);
    if (passwordError) return setError(passwordError);
    setLoading(true);
    try {
      const res = await fetch("/api/player/change-password", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ currentPassword: form.currentPassword, newPassword: form.newPassword })
      });
      const data = await res.json();
      if (!res.ok) return setError(data.error || "Failed to change password");
      setSuccess("Password changed successfully!");
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
      setTimeout(() => navigate("/player/dashboard"), 2000);
    } catch(e) { setError("Network error"); }
    finally { setLoading(false); }
  };

  return (
    <PlayerLayout>
      <h1 style={{ fontSize: "20px", fontWeight: "800", color: "#14532d", marginBottom: "20px" }}>Change Password</h1>
      <div style={{ background: "white", padding: "32px", borderRadius: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", maxWidth: "420px" }}>

        {forced && (
          <div style={{ background: "#fffbeb", border: "1px solid #fde68a", color: "#92400e", padding: "10px 14px", borderRadius: "8px", marginBottom: "16px", fontSize: "13px" }}>
            For account security, you need to set a stronger password before continuing.
          </div>
        )}
        {error && <div style={{ background: "#fee2e2", color: "#b91c1c", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{error}</div>}
        {success && <div style={{ background: "#dcfce7", color: "#166534", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{success}</div>}

        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>Current Password</label>
            <PasswordInput value={form.currentPassword} onChange={e => setForm({ ...form, currentPassword: e.target.value })}
              style={{ width: "100%", border: "1.5px solid #d1d5db", borderRadius: "8px", padding: "11px 14px", fontSize: "15px", boxSizing: "border-box" }} />
          </div>
          <div>
            <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>New Password</label>
            <PasswordInput value={form.newPassword} onChange={e => setForm({ ...form, newPassword: e.target.value })}
              style={{ width: "100%", border: "1.5px solid #d1d5db", borderRadius: "8px", padding: "11px 14px", fontSize: "15px", boxSizing: "border-box" }} />
            <p style={{ fontSize: "13px", fontWeight: "600", color: "#4b5563", marginTop: "6px" }}>{PASSWORD_HINT}</p>
          </div>
          <div>
            <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#374151", marginBottom: "6px" }}>Confirm New Password</label>
            <PasswordInput value={form.confirmPassword} onChange={e => setForm({ ...form, confirmPassword: e.target.value })}
              onKeyDown={e => e.key === "Enter" && handleSubmit()}
              style={{ width: "100%", border: "1.5px solid #d1d5db", borderRadius: "8px", padding: "11px 14px", fontSize: "15px", boxSizing: "border-box" }} />
          </div>
          <button onClick={handleSubmit} disabled={loading}
            style={{ width: "100%", background: loading ? "#86efac" : "#166534", color: "white", fontWeight: "700", fontSize: "16px", padding: "13px", borderRadius: "8px", border: "none", cursor: loading ? "not-allowed" : "pointer" }}>
            {loading ? "Changing..." : "Change Password"}
          </button>
          {!forced && (
            <button onClick={() => navigate("/player/dashboard")}
              style={{ width: "100%", background: "#f3f4f6", color: "#374151", fontWeight: "600", fontSize: "14px", padding: "11px", borderRadius: "8px", border: "none", cursor: "pointer" }}>
              Cancel
            </button>
          )}
        </div>
      </div>
    </PlayerLayout>
  );
}
